import { OpinionsItemsInterface } from 'interfaces/opinions.interface';

const sortOpinions = (opinions: OpinionsItemsInterface[]): OpinionsItemsInterface[] => opinions
    .sort((a: OpinionsItemsInterface, b: OpinionsItemsInterface) => b.content.length - a.content.length)
    .sort((a: OpinionsItemsInterface, b: OpinionsItemsInterface) => b.rating - a.rating);

export default sortOpinions;
